import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {QueryControlComponent} from './components/query-control/query-control.component';
import {
  StringQueryControlComponent
} from './components/type-controls/string-query-control/string-query-control.component';
import {FormsModule} from '@angular/forms';
import {CheckboxModule} from 'primeng/checkbox';
import {DateQueryControlComponent} from './components/type-controls/date-query-control/date-query-control.component';
import {CalendarModule} from 'primeng/calendar';
import {EnumQueryControlComponent} from './components/type-controls/enum-query-control/enum-query-control.component';
import {SelectButtonModule} from 'primeng/selectbutton';
import {
  CustomerQueryControlComponent
} from './components/type-controls/customer-query-control/customer-query-control.component';
import {
  WorkerQueryControlComponent
} from './components/type-controls/worker-query-control/worker-query-control.component';
import {AppCommonModule} from '../app-common/app-common.module';
import {VirtualScrollModule} from '../virtual-scroll/virtual-scroll.module';
import {UserModule} from '../user/user.module';
import {RippleModule} from 'primeng/ripple';
import {AccordionModule} from 'primeng/accordion';
import {StyleClassModule} from 'primeng/styleclass';
import {CommunicationCommonModule} from '../communication-common/communication-common.module';
import {WidgetLibraryModule} from '../_widget-library/widget-library.module';
import {LayoutLibraryModule} from '../_layout-library/layout-library.module';
import { MultiColumnControlComponent } from './components/type-controls/multi-column-control/multi-column-control.component';
import { MasterControlComponent } from './components/type-controls/master-control/master-control.component';
import { NumberQueryControlComponent } from './components/type-controls/number-query-control/number-query-control.component';
import {FlagQueryControlComponent} from "./components/type-controls/flag-query-control/flag-query-control.component";
import { MultiSelectModule } from 'primeng/multiselect';


@NgModule({
  declarations: [
    QueryControlComponent,
    StringQueryControlComponent,
    DateQueryControlComponent,
    EnumQueryControlComponent,
    CustomerQueryControlComponent,
    WorkerQueryControlComponent,
    NumberQueryControlComponent,
    MultiColumnControlComponent,
    MasterControlComponent,
    FlagQueryControlComponent,

  ],
  exports: [
    QueryControlComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    CheckboxModule,
    CalendarModule,
    SelectButtonModule,
    AppCommonModule,
    VirtualScrollModule,
    UserModule,
    RippleModule,
    AccordionModule,
    StyleClassModule,
    CommunicationCommonModule,
    WidgetLibraryModule,
    LayoutLibraryModule,
    MultiSelectModule,
  ]
})
export class QueryModule {
}
